"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "paginationSerializer", {
  enumerable: true,
  get: function get() {
    return _paginationSerializer.default;
  }
});
Object.defineProperty(exports, "getLimitOffset", {
  enumerable: true,
  get: function get() {
    return _utils.getLimitOffset;
  }
});
exports.constants = exports.default = void 0;

var _axios = _interopRequireDefault(require("axios"));

var constants = _interopRequireWildcard(require("./constants"));

exports.constants = constants;

var _paginationSerializer = _interopRequireDefault(require("./serializers/paginationSerializer"));

var _utils = require("./utils");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AUTH_TOKEN_KEY = 'auth_token';

var BaseApi = function BaseApi(_url) {
  var _this = this;

  _classCallCheck(this, BaseApi);

  _defineProperty(this, "axiosOverride", function (axios) {
    var Token = _this.getAuthToken();

    axios.defaults.headers.common['Authorization'] = "Token ".concat(Token);
    return axios;
  });

  _defineProperty(this, "post", /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url, params) {
      var axiosParams,
          _args = arguments;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              axiosParams = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
              _context.next = 3;
              return _this.send(url, 'post', params, axiosParams);

            case 3:
              return _context.abrupt("return", _context.sent);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());

  _defineProperty(this, "get", /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(url, params) {
      var axiosParams,
          base_url,
          newAxios,
          res,
          _args2 = arguments;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              axiosParams = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
              base_url = _this.url;
              newAxios = _this.axiosOverride(_axios.default);
              _context2.next = 5;
              return newAxios(_objectSpread({
                method: 'get',
                params: params,
                url: "".concat(base_url).concat(url)
              }, axiosParams));

            case 5:
              res = _context2.sent;
              return _context2.abrupt("return", res);

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }());

  _defineProperty(this, "put", /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(url, params) {
      var axiosParams,
          _args3 = arguments;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              axiosParams = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : {};
              _context3.next = 3;
              return _this.send(url, 'put', params, axiosParams);

            case 3:
              return _context3.abrupt("return", _context3.sent);

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }());

  _defineProperty(this, "patch", /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(url, params) {
      var axiosParams,
          _args4 = arguments;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              axiosParams = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
              _context4.next = 3;
              return _this.send(url, 'patch', params, axiosParams);

            case 3:
              return _context4.abrupt("return", _context4.sent);

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }());

  _defineProperty(this, "delete", /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(url, params) {
      var axiosParams,
          _args5 = arguments;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              axiosParams = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : {};
              _context5.next = 3;
              return _this.send(url, 'delete', params, axiosParams);

            case 3:
              return _context5.abrupt("return", _context5.sent);

            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x9, _x10) {
      return _ref5.apply(this, arguments);
    };
  }());

  _defineProperty(this, "send", /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(url, method, params) {
      var axiosParams,
          base_url,
          newAxios,
          res,
          _args6 = arguments;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              axiosParams = _args6.length > 3 && _args6[3] !== undefined ? _args6[3] : {};
              base_url = _this.url;
              newAxios = _this.axiosOverride(_axios.default);
              _context6.next = 5;
              return newAxios(_objectSpread({
                method: method,
                data: params,
                url: "".concat(base_url).concat(url)
              }, axiosParams));

            case 5:
              res = _context6.sent;
              return _context6.abrupt("return", res);

            case 7:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x11, _x12, _x13) {
      return _ref6.apply(this, arguments);
    };
  }());

  this.url = _url;

  this.getAuthToken = function () {
    return localStorage.getItem(AUTH_TOKEN_KEY);
  };

  this.setAuthToken = function (token) {
    localStorage.setItem(AUTH_TOKEN_KEY, token);
    return true;
  };

  this.removeAuthToken = function () {
    try {
      localStorage.removeItem(AUTH_TOKEN_KEY);
      return true;
    } catch (_unused) {
      return false; // no key
    }
  };
};

var _default = BaseApi;
exports.default = _default;